/**
 * Liens sociaux publics de KaneaBourse.
 *
 * Source unique : la landing, le footer et la nav pointent tous ici, et l'URL est
 * aussi déclarée côté SEO dans le `sameAs` du JSON-LD Organization de
 * `ui/public/index.html` — penser à la mettre à jour aux deux endroits.
 */
export const INSTAGRAM_URL = 'https://www.instagram.com/kaneabourse';
